import { render, staticRenderFns } from "./wechatOa__list.vue?vue&type=template&id=4c0dd4ed"
import script from "./wechatOa__list.vue?vue&type=script&lang=js"
export * from "./wechatOa__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports